// src/componentes/ClienteDetalle/ClienteDetalle.jsx
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import {
  doc,
  getDoc,
  updateDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../../Firebase/firebaseconfig";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import LlamadasCliente from "./LlamadasCliente";
import { isCallCenterUiEnabled } from "../../helpers/callCenterFlags";
import {
  FaEye,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaBirthdayCake,
  FaMoneyCheckAlt,
  FaPlusCircle,
  FaEdit,
  FaPrint,
  FaFileArchive,
  FaClipboardList,
  FaHandshake,
  FaHome,
} from "react-icons/fa";
import TarjetaCliente from "../Clientes/TarjetaCliente";
import notify from "../common/notify";
import "./ClienteDetalle.css";
import { generarTarjetaClientePdf } from "../../helpers/pdfTarjetaCliente";
import { toJsDate, formatFecha, formatFechaSolo } from "../../helpers/fechas";

import Barcode from "react-barcode";
import html2canvas from "html2canvas";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import logo from "../../logokye.png";
import { useUserContext } from "../GestionDeUsuarios/UserContext";
import {
  marcarEstadoTelefono,
  getLabelEstado,
} from "../../services/telefonoService";
import TelefonoEstadoControl from "../Telefono/TelefonoEstadoControl";

const formatMoney = (value) =>
  Number(value || 0).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
  });

const getDateValue = (value) => toJsDate(value);

const formatShortDate = (value) => {
  const date = getDateValue(value);
  return date ? date.toLocaleDateString("es-MX") : "Sin fecha";
};

const TarjetaClienteFrenteImagen = ({ cliente, deudaPrincipal }) => {
  const codigoCliente = cliente.id;
  const fotoCliente = cliente.fotoPerfil || "/perfil-cliente.png";

  return (
    <div id="tarjeta-cliente-frente" style={{
      width: "856px",
      height: "540px",
      borderRadius: "20px",
      border: "1px solid #d1d5db",
      fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      backgroundColor: "#ffffff",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
    }}>
      <div style={{
        backgroundColor: "#f3f4f6",
        padding: "22px 32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #e5e7eb",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
          <img src={logo} alt="Logo K&E" style={{ height: "70px", width: "auto" }} />
          <div>
            <div style={{ fontWeight: 700, fontSize: "22px", color: "#111827" }}>
              GRUPO INMOBILIARIO K&E
            </div>
            <div style={{ fontSize: "15px", color: "#4b5563" }}>
              Tarjeta de Cliente
            </div>
          </div>
        </div>

        <div style={{
          height: "38px",
          padding: "0 18px",
          borderRadius: "999px",
          background: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)",
          display: "flex",
          alignItems: "center",
          color: "#eef2ff",
          fontSize: "13px",
          fontWeight: 600,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
        }}>
          ID: {cliente.id}
        </div>
      </div>

      <div style={{
        flex: 1,
        padding: "30px 44px 32px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}>
        <div>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "18px",
            marginBottom: "16px",
          }}>
            <img src={fotoCliente} alt="Foto del cliente" style={{
              width: "88px",
              height: "88px",
              borderRadius: "999px",
              objectFit: "cover",
              border: "3px solid #e5e7eb",
            }} />
            <div>
              <div style={{ fontSize: "26px", fontWeight: 700, color: "#111827" }}>
                {cliente.nombre} {cliente.apellidos}
              </div>
              <div style={{ fontSize: "14px", color: "#4b5563", marginTop: "4px" }}>
                ID: <strong>{cliente.id}</strong>
                {cliente.folio && (
                  <>
                    {"  •  "}
                    Folio cliente: <strong>{cliente.folio}</strong>
                  </>
                )}
              </div>
            </div>
          </div>

          <div style={{
            height: "1px",
            background: "linear-gradient(90deg, #2563eb 0%, #e5e7eb 40%, #e5e7eb 100%)",
            marginBottom: "20px",
          }} />

          {deudaPrincipal && (
            <div style={{
              fontSize: "15px",
              color: "#111827",
              backgroundColor: "#f9fafb",
              padding: "12px 18px",
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}>
              <span style={{ fontWeight: 700, color: "#1d4ed8" }}>
                Deuda principal:
              </span>
              <span style={{ fontWeight: 500 }}>
                {deudaPrincipal.folio || deudaPrincipal.id}
              </span>
            </div>
          )}
        </div>

        <div style={{
          textAlign: "center",
          padding: "20px 22px",
          backgroundColor: "#f9fafb",
          borderRadius: "12px",
          border: "1px solid #e5e7eb",
        }}>
          <div style={{
            fontSize: "14px",
            fontWeight: 600,
            color: "#4b5563",
            marginBottom: "14px",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
          }}>
            ID CLIENTE
          </div>
          <Barcode
            value={codigoCliente}
            format="CODE128"
            width={2.2}
            height={90}
            displayValue
            margin={0}
            fontSize={16}
            background="#f9fafb"
            lineColor="#000000"
          />
        </div>
      </div>
    </div>
  );
};

const TarjetaClienteReversoImagen = ({ cliente, deudas }) => {
  const lista = (deudas || []).slice(0, 3);

  return (
    <div id="tarjeta-cliente-reverso" style={{
      width: "540px",
      height: "856px",
      borderRadius: "20px",
      border: "1px solid #d1d5db",
      fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      backgroundColor: "#ffffff",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
    }}>
      <div style={{
        backgroundColor: "#f3f4f6",
        padding: "18px 22px",
        borderBottom: "1px solid #e5e7eb",
        display: "flex",
        alignItems: "center",
        gap: "14px",
      }}>
        <img src={logo} alt="Logo K&E" style={{ height: "46px", width: "auto" }} />
        <div>
          <div style={{ fontWeight: 700, fontSize: "18px", color: "#111827" }}>
            Deudas del Cliente
          </div>
          <div style={{ fontSize: "13px", color: "#4b5563" }}>
            {cliente.nombre} {cliente.apellidos}
          </div>
        </div>
      </div>

      <div style={{
        flex: 1,
        padding: "22px 26px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        justifyContent: lista.length === 0 ? "center" : "flex-start",
      }}>
        {lista.length === 0 && (
          <div style={{
            textAlign: "center",
            fontSize: "14px",
            color: "#9ca3af",
            fontStyle: "italic",
          }}>
            Sin deudas registradas.
          </div>
        )}

        {lista.map((deuda, idx) => {
          const folio = deuda.folio || deuda.id;
          const conceptoFull = (deuda.concepto || deuda.tipo || "").toString().trim();
          const concepto =
            conceptoFull.length > 70 ? `${conceptoFull.slice(0, 67)}...` : conceptoFull;

          return (
            <div key={deuda.id} style={{
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
              padding: "14px 16px",
              backgroundColor: "#ffffff",
              boxShadow: "0 2px 8px rgba(15, 23, 42, 0.06)",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}>
              <div>
                <div style={{
                  fontSize: "12px",
                  fontWeight: 700,
                  color: "#111827",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}>
                  {idx + 1}. Folio {folio}
                </div>
                {concepto && (
                  <div style={{ fontSize: "12px", color: "#374151", lineHeight: 1.5 }}>
                    {concepto}
                  </div>
                )}
              </div>

              <div style={{
                padding: "8px 10px 4px",
                backgroundColor: "#f9fafb",
                borderRadius: "8px",
                display: "flex",
                justifyContent: "center",
              }}>
                <Barcode
                  value={deuda.id}
                  format="CODE128"
                  width={1.6}
                  height={52}
                  displayValue={false}
                  margin={0}
                  background="#f9fafb"
                  lineColor="#000000"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ClienteDetalle = () => {
  const { id } = useParams();
  const { can } = useUserContext();

  const [cliente, setCliente] = useState(null);
  const [archivo, setArchivo] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const [vistaPrevia, setVistaPrevia] = useState(null);
  const [documentos, setDocumentos] = useState({
    ine: null,
    curp: null,
    comprobante: null,
  });
  const [deudas, setDeudas] = useState([]);
  const [promesasPago, setPromesasPago] = useState([]);
  const [gestionesCobranza, setGestionesCobranza] = useState([]);
  const [ticketsCliente, setTicketsCliente] = useState([]);
  const [mostrarTarjeta] = useState(false);
  const [capturandoTarjeta, setCapturandoTarjeta] = useState(false);
  const [ficha360Tab, setFicha360Tab] = useState("resumen");

  const puedeSubirDocumentos = can("clientes.subirDocumentos");
  const puedeVerDocumentos = can("clientes.verDocumentos");
  const puedeVerDeudas = can("deudas.ver");
  const puedeCrearDeudas = can("deudas.crear");
  const puedeEditarCliente = can("clientes.editar");
  const puedeDescargarPdf = can("deudas.descargarPDF");
  const puedeVerPromesas = can("cobranza.promesas.ver");
  const puedeVerGestiones = can("cobranza.gestiones.ver");
  const puedeVerTickets = can("tickets.ver");

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const clienteRef = doc(db, "clientes", id);
        const deudasQ = query(collection(db, "deudas"), where("clienteId", "==", id));

        const consultas = [getDoc(clienteRef), getDocs(deudasQ)];

        if (puedeVerPromesas) {
          consultas.push(
            getDocs(query(collection(db, "promesasPago"), where("clienteId", "==", id)))
          );
        }

        if (puedeVerGestiones) {
          consultas.push(
            getDocs(query(collection(db, "gestionesCobranza"), where("clienteId", "==", id)))
          );
        }

        if (puedeVerTickets) {
          consultas.push(
            getDocs(
              query(
                collection(db, "tickets"),
                where("entidadTipo", "==", "cliente"),
                where("entidadId", "==", id)
              )
            )
          );
        }

        const [clienteSnap, deudasSnap, ...extraSnaps] = await Promise.all(consultas);

        if (!isMounted) return;

        if (clienteSnap.exists()) {
          setCliente(clienteSnap.data());
        }

        setDeudas(
          deudasSnap.docs.map((d) => ({
            id: d.id,
            ...d.data(),
          }))
        );

        let extraIndex = 0;

        if (puedeVerPromesas) {
          const snap = extraSnaps[extraIndex];
          extraIndex += 1;
          setPromesasPago(
            (snap?.docs || []).map((d) => ({
              id: d.id,
              ...d.data(),
            }))
          );
        } else {
          setPromesasPago([]);
        }

        if (puedeVerGestiones) {
          const snap = extraSnaps[extraIndex];
          extraIndex += 1;
          setGestionesCobranza(
            (snap?.docs || []).map((d) => ({
              id: d.id,
              ...d.data(),
            }))
          );
        } else {
          setGestionesCobranza([]);
        }

        if (puedeVerTickets) {
          const snap = extraSnaps[extraIndex];
          setTicketsCliente(
            (snap?.docs || []).map((d) => ({
              id: d.id,
              ...d.data(),
            }))
          );
        } else {
          setTicketsCliente([]);
        }

      } catch (error) {
        console.error("Error cargando detalle del cliente:", error);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [id, puedeVerGestiones, puedeVerPromesas, puedeVerTickets]);

  const handleArchivoChange = useCallback((e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setArchivo(file);

    const reader = new FileReader();
    reader.onloadend = () => setVistaPrevia(reader.result);
    reader.readAsDataURL(file);
  }, []);

  const subirImagen = useCallback(async () => {
    if (!archivo) return;

    setSubiendo(true);

    try {
      const storage = getStorage();
      const ext = archivo.name.split(".").pop();
      const storageRef = ref(storage, `clientes/${id}/perfil.${ext}`);

      await uploadBytes(storageRef, archivo, { contentType: archivo.type });

      const url = await getDownloadURL(storageRef);
      await updateDoc(doc(db, "clientes", id), { fotoPerfil: url });

      setCliente((prev) => ({ ...prev, fotoPerfil: url }));
      notify.success("Imagen subida exitosamente");
    } catch (error) {
      console.error("Error al subir imagen:", error);
      notify.error(`Error al subir imagen: ${error.message}`);
    } finally {
      setSubiendo(false);
    }
  }, [archivo, id]);

  const handleDocumentoChange = useCallback((tipo, file) => {
    setDocumentos((prev) => ({ ...prev, [tipo]: file }));
  }, []);

  const subirDocumento = useCallback(
    async (tipo) => {
      const archivoDoc = documentos[tipo];

      if (!archivoDoc) {
        notify.error(`Selecciona un archivo para ${tipo}`);
        return;
      }

      setSubiendo(true);

      try {
        const ext = archivoDoc.name.split(".").pop();
        const storage = getStorage();
        const docRefStorage = ref(storage, `clientes/${id}/documentos/${tipo}.${ext}`);

        await uploadBytes(docRefStorage, archivoDoc, {
          contentType: archivoDoc.type,
        });

        const url = await getDownloadURL(docRefStorage);
        const nuevosDocs = { ...(cliente?.documentos || {}), [tipo]: url };

        await updateDoc(doc(db, "clientes", id), { documentos: nuevosDocs });
        setCliente((prev) => ({ ...prev, documentos: nuevosDocs }));

        notify.success(`Documento ${tipo.toUpperCase()} subido correctamente`);
      } catch (error) {
        console.error("Error al subir documento:", error);
        notify.error(`Error al subir documento ${tipo.toUpperCase()}: ${error.message}`);
      } finally {
        setSubiendo(false);
      }
    },
    [documentos, id, cliente]
  );

  const deudaPrincipal = useMemo(
    () => (deudas.length > 0 ? deudas[0] : null),
    [deudas]
  );

  const pagosRecientes = useMemo(() => {
    const pagos = deudas.flatMap((deuda) =>
      (deuda.pagos || []).map((pago) => ({
        ...pago,
        deudaId: deuda.id,
        deudaFolio: deuda.folio || deuda.id,
        fechaOrden: getDateValue(pago.fecha || pago.fechaPago || pago.creadoEn)?.getTime() || 0,
      }))
    );

    return pagos.sort((a, b) => b.fechaOrden - a.fechaOrden);
  }, [deudas]);

  const propiedadesRelacionadas = useMemo(() => {
    const mapa = new Map();

    deudas.forEach((deuda) => {
      const propiedades = Array.isArray(deuda.propiedades) ? deuda.propiedades : [];

      propiedades.forEach((propiedad, index) => {
        const key =
          propiedad.id ||
          propiedad.propiedadId ||
          propiedad.folio ||
          propiedad.codigo ||
          `${deuda.id}-${index}`;

        if (!mapa.has(key)) {
          mapa.set(key, {
            id: key,
            folio: propiedad.folio || propiedad.codigo || propiedad.codigoHumano || "Propiedad",
            detalle: [
              propiedad.fraccionamiento || propiedad.fraccNombre,
              propiedad.manzana ? `Mz ${propiedad.manzana}` : "",
              propiedad.lote ? `Lt ${propiedad.lote}` : "",
            ]
              .filter(Boolean)
              .join(" - "),
          });
        }
      });
    });

    return Array.from(mapa.values()).slice(0, 6);
  }, [deudas]);

  const ficha360 = useMemo(() => {
    const saldoTotal = deudas.reduce(
      (acc, deuda) =>
        acc +
        Number(
          deuda.saldoPendiente ||
            deuda.saldoRestante ||
            deuda.saldo ||
            deuda.montoTotal ||
            deuda.total ||
            0
        ),
      0
    );

    const promesasPendientes = promesasPago.filter(
      (promesa) => promesa.estado === "pendiente"
    );

    const ticketsAbiertos = ticketsCliente.filter(
      (ticket) => !["cerrado", "resuelto"].includes(ticket.estado)
    );

    return {
      saldoTotal,
      deudasTotal: deudas.length,
      pagosRecientes: pagosRecientes.length,
      promesasPendientes: promesasPendientes.length,
      gestionesTotal: gestionesCobranza.length,
      ticketsAbiertos: ticketsAbiertos.length,
      propiedadesTotal: propiedadesRelacionadas.length,
    };
  }, [
    deudas,
    gestionesCobranza.length,
    pagosRecientes.length,
    promesasPago,
    propiedadesRelacionadas.length,
    ticketsCliente,
  ]);

  const promesasOrdenadas = useMemo(
    () =>
      [...promesasPago]
        .sort((a, b) => {
          const aDate = getDateValue(a.fechaPromesa)?.getTime() || 0;
          const bDate = getDateValue(b.fechaPromesa)?.getTime() || 0;
          return bDate - aDate;
        }),
    [promesasPago]
  );

  const gestionesOrdenadas = useMemo(
    () =>
      [...gestionesCobranza]
        .sort((a, b) => {
          const aDate = getDateValue(a.creadoEn)?.getTime() || 0;
          const bDate = getDateValue(b.creadoEn)?.getTime() || 0;
          return bDate - aDate;
        }),
    [gestionesCobranza]
  );

  const ticketsOrdenados = useMemo(
    () =>
      [...ticketsCliente]
        .sort((a, b) => {
          const aDate = getDateValue(a.updatedAt || a.createdAt)?.getTime() || 0;
          const bDate = getDateValue(b.updatedAt || b.createdAt)?.getTime() || 0;
          return bDate - aDate;
        }),
    [ticketsCliente]
  );

  const ficha360Tabs = useMemo(
    () =>
      [
        { key: "resumen", label: "Resumen" },
        { key: "deudas", label: "Deudas" },
        { key: "pagos", label: "Pagos" },
        puedeVerGestiones && { key: "gestiones", label: "Gestiones" },
        puedeVerGestiones && isCallCenterUiEnabled() && { key: "llamadas", label: "Llamadas" },
        puedeVerTickets && { key: "tickets", label: "Tickets" },
        { key: "documentos", label: "Documentos" },
      ].filter(Boolean),
    [puedeVerGestiones, puedeVerTickets]
  );

  useEffect(() => {
    if (!ficha360Tabs.some((tab) => tab.key === ficha360Tab)) {
      setFicha360Tab("resumen");
    }
  }, [ficha360Tab, ficha360Tabs]);

  const imprimirTarjeta = useCallback(() => {
    if (!cliente) return;
    generarTarjetaClientePdf({ id, ...cliente }, deudaPrincipal, deudas);
  }, [cliente, deudaPrincipal, deudas, id]);

  const handleDescargarTarjetaZip = useCallback(async () => {
    if (!cliente) return;

    setCapturandoTarjeta(true);
    await new Promise((r) => setTimeout(r, 200));

    try {
      const frenteEl = document.getElementById("tarjeta-cliente-frente");
      const reversoEl = document.getElementById("tarjeta-cliente-reverso");

      if (!frenteEl || !reversoEl) return;

      const nombreBase = `${cliente.nombre || ""}_${cliente.apellidos || ""}`
        .trim()
        .replace(/\s+/g, "_")
        .toLowerCase();

      const canvasFrente = await html2canvas(frenteEl, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const canvasReverso = await html2canvas(reversoEl, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const dataUrlToUint8Array = (dataUrl) => {
        const arr = dataUrl.split(",");
        const bstr = atob(arr[1]);
        const u8arr = new Uint8Array(bstr.length);

        for (let i = 0; i < bstr.length; i += 1) {
          u8arr[i] = bstr.charCodeAt(i);
        }

        return u8arr;
      };

      const zip = new JSZip();

      zip.file(
        `${nombreBase}_frente.png`,
        dataUrlToUint8Array(canvasFrente.toDataURL("image/png"))
      );

      zip.file(
        `${nombreBase}_reverso.png`,
        dataUrlToUint8Array(canvasReverso.toDataURL("image/png"))
      );

      const contenido = await zip.generateAsync({ type: "blob" });
      saveAs(contenido, `${nombreBase}_tarjeta_cliente.zip`);
    } finally {
      setCapturandoTarjeta(false);
    }
  }, [cliente]);

  if (!cliente) {
    return <div className="cliente-detalle">Cargando datos del cliente...</div>;
  }

  return (
    <>
      <div className={`cliente-carnet ${mostrarTarjeta ? "ocultar-en-impresion" : ""}`}>
        <div className="carnet-header">
          <img
            src={vistaPrevia || cliente.fotoPerfil || "/perfil-cliente.png"}
            alt="Foto del Cliente"
            className="carnet-foto"
          />

          <div className="carnet-header-info">
            <h2>
              {cliente.nombre} {cliente.apellidos}
            </h2>
            <p className="carnet-subtitulo">ID: {id}</p>
            {cliente.folio && <p className="carnet-subtitulo">Folio: {cliente.folio}</p>}
          </div>
        </div>

        <div className="carnet-info">
          <p><FaEnvelope /> <strong>Email:</strong> {cliente.email}</p>
          <p>
            <FaPhone /> <strong>Telefono:</strong> {cliente.telefono || "—"}
            <TelefonoEstadoControl
              cliente={cliente}
              onCambio={async (estado, motivo) => {
                try {
                  await marcarEstadoTelefono(id, estado, motivo);
                  notify.success(
                    estado === "valido"
                      ? "Telefono restaurado a valido."
                      : `Telefono marcado como "${getLabelEstado(estado)}".`,
                  );
                  // Refrescar local: el onSnapshot del cliente (si existe) actualizara;
                  // por si acaso, forzar fetch puntual:
                  setCliente((prev) =>
                    prev
                      ? {
                          ...prev,
                          telefonoEstado: estado,
                          telefonoEstadoMotivo: motivo || "",
                        }
                      : prev,
                  );
                } catch (err) {
                  notify.error(`No se pudo marcar el telefono: ${err?.message || err}`);
                }
              }}
            />
          </p>
          <p><FaMapMarkerAlt /> <strong>Direccion:</strong> {cliente.direccion}</p>
          <p><FaBirthdayCake /> <strong>Fecha de nacimiento:</strong> {formatFechaSolo(cliente.fechaNacimiento, "—")}</p>
        </div>

        <section className="cliente-360-section">
          <div className="cliente-360-header">
            <div>
              <span className="cliente-360-eyebrow">Ficha 360</span>
              <h3>Actividad y contexto del cliente</h3>
            </div>
            <span className="cliente-360-total">
              Saldo relacionado: {formatMoney(ficha360.saldoTotal)}
            </span>
          </div>

          <div className="cliente-360-kpis">
            <div>
              <strong>{ficha360.deudasTotal}</strong>
              <span>Deudas</span>
            </div>
            <div>
              <strong>{ficha360.pagosRecientes}</strong>
              <span>Pagos</span>
            </div>
            <div>
              <strong>{ficha360.promesasPendientes}</strong>
              <span>Promesas pendientes</span>
            </div>
            <div>
              <strong>{ficha360.gestionesTotal}</strong>
              <span>Gestiones</span>
            </div>
            <div>
              <strong>{ficha360.ticketsAbiertos}</strong>
              <span>Tickets abiertos</span>
            </div>
          </div>

          <div className="cliente-360-tabs" role="tablist" aria-label="Ficha 360">
            {ficha360Tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={ficha360Tab === tab.key ? "active" : ""}
                onClick={() => setFicha360Tab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="cliente-360-panel">
            {ficha360Tab === "resumen" && (
              <div className="cliente-360-grid">
                <article className="cliente-360-card">
                  <h4><FaClipboardList /> Deudas</h4>
                  {deudas.slice(0, 4).map((deuda) => (
                    <div key={deuda.id} className="cliente-360-row">
                      <span>{deuda.folio || deuda.id}</span>
                      <strong>{formatMoney(deuda.saldoPendiente || deuda.saldoRestante || deuda.saldo || deuda.montoTotal || 0)}</strong>
                    </div>
                  ))}
                  {deudas.length === 0 && <p className="cliente-360-empty">Sin deudas registradas.</p>}
                </article>

                <article className="cliente-360-card">
                  <h4><FaMoneyCheckAlt /> Pagos recientes</h4>
                  {pagosRecientes.slice(0, 4).map((pago, index) => (
                    <div key={`${pago.deudaId}-${pago.fechaOrden}-${index}`} className="cliente-360-row">
                      <span>{formatShortDate(pago.fecha || pago.fechaPago || pago.creadoEn)}</span>
                      <strong>{formatMoney(pago.monto || pago.cantidad || pago.total || 0)}</strong>
                    </div>
                  ))}
                  {pagosRecientes.length === 0 && <p className="cliente-360-empty">Sin pagos recientes.</p>}
                </article>

                {puedeVerPromesas && (
                  <article className="cliente-360-card">
                    <h4><FaHandshake /> Promesas</h4>
                    {promesasOrdenadas.slice(0, 4).map((promesa) => (
                      <div key={promesa.id} className="cliente-360-row">
                        <span>{formatShortDate(promesa.fechaPromesa)} - {promesa.estado}</span>
                        <strong>{formatMoney(promesa.montoPrometido)}</strong>
                      </div>
                    ))}
                    {promesasOrdenadas.length === 0 && <p className="cliente-360-empty">Sin promesas registradas.</p>}
                  </article>
                )}

                <article className="cliente-360-card">
                  <h4><FaHome /> Propiedades</h4>
                  {propiedadesRelacionadas.slice(0, 4).map((propiedad) => (
                    <div key={propiedad.id} className="cliente-360-note">
                      <strong>{propiedad.folio}</strong>
                      <span>{propiedad.detalle || "Relacionada por deuda"}</span>
                    </div>
                  ))}
                  {propiedadesRelacionadas.length === 0 && <p className="cliente-360-empty">Sin propiedades relacionadas.</p>}
                </article>
              </div>
            )}

            {ficha360Tab === "deudas" && (
              <div className="cliente-360-list">
                {deudas.map((deuda) => (
                  <div key={deuda.id} className="cliente-360-row">
                    <span>{deuda.folio || deuda.id}</span>
                    <strong>{formatMoney(deuda.saldoPendiente || deuda.saldoRestante || deuda.saldo || deuda.montoTotal || 0)}</strong>
                  </div>
                ))}
                {deudas.length === 0 && <p className="cliente-360-empty">Sin deudas registradas.</p>}
              </div>
            )}

            {ficha360Tab === "pagos" && (
              <div className="cliente-360-list">
                {pagosRecientes.map((pago, index) => (
                  <div key={`${pago.deudaId}-${pago.fechaOrden}-${index}`} className="cliente-360-row">
                    <span>{formatShortDate(pago.fecha || pago.fechaPago || pago.creadoEn)} - {pago.deudaFolio}</span>
                    <strong>{formatMoney(pago.monto || pago.cantidad || pago.total || 0)}</strong>
                  </div>
                ))}
                {pagosRecientes.length === 0 && <p className="cliente-360-empty">Sin pagos registrados.</p>}
              </div>
            )}

            {ficha360Tab === "gestiones" && puedeVerGestiones && (
              <div className="cliente-360-list">
                {gestionesOrdenadas.map((gestion) => (
                  <div key={gestion.id} className="cliente-360-note">
                    <strong>{gestion.tipo || "Gestion"} - {formatShortDate(gestion.creadoEn)}</strong>
                    <span>{gestion.resultado || gestion.comentario || "Sin resultado"}</span>
                  </div>
                ))}
                {gestionesOrdenadas.length === 0 && <p className="cliente-360-empty">Sin gestiones registradas.</p>}
              </div>
            )}

            {ficha360Tab === "llamadas" && puedeVerGestiones && isCallCenterUiEnabled() && (
              <div className="cliente-360-list">
                <LlamadasCliente clienteId={id} />
              </div>
            )}

            {ficha360Tab === "tickets" && puedeVerTickets && (
              <div className="cliente-360-list">
                {ticketsOrdenados.map((ticket) => (
                  <div key={ticket.id} className="cliente-360-row">
                    <span>{ticket.titulo || "Ticket sin titulo"}</span>
                    <strong>{ticket.estado || "abierto"}</strong>
                  </div>
                ))}
                {ticketsOrdenados.length === 0 && <p className="cliente-360-empty">Sin tickets vinculados.</p>}
              </div>
            )}

            {ficha360Tab === "documentos" && (
              <div className="cliente-360-list">
                {["ine", "curp", "comprobante"].map((tipo) => (
                  <div key={tipo} className="cliente-360-row">
                    <span>{tipo.toUpperCase()}</span>
                    {cliente.documentos?.[tipo] && puedeVerDocumentos ? (
                      <a href={cliente.documentos[tipo]} target="_blank" rel="noopener noreferrer">
                        Ver documento
                      </a>
                    ) : (
                      <strong>Faltante</strong>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        {puedeSubirDocumentos && (
          <div className="subida-imagen">
            <label className="boton-archivo">
              Seleccionar archivo
              <input type="file" accept=".jpg,.jpeg,.png,.webp" onChange={handleArchivoChange} />
            </label>

            <span className="nombre-archivo">
              {archivo?.name || "Sin archivos seleccionados"}
            </span>

            <button type="button" onClick={subirImagen} disabled={subiendo || !archivo}>
              {subiendo ? "Subiendo..." : "Subir Imagen de Perfil"}
            </button>
          </div>
        )}

        <div className="documentos-section">
          <h3>Documentos del Cliente</h3>

          {["ine", "curp", "comprobante"].map((tipo) => (
            <div key={tipo} className="documento-upload-block">
              <p className="documento-titulo">{tipo.toUpperCase()}</p>

              {puedeSubirDocumentos && (
                <div className="input-archivo-personalizado">
                  <label className="boton-archivo">
                    Seleccionar archivo
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={(e) => handleDocumentoChange(tipo, e.target.files?.[0])}
                    />
                  </label>

                  <span className="nombre-archivo">
                    {documentos[tipo]?.name || "Sin archivo seleccionado"}
                  </span>

                  <button
                    type="button"
                    onClick={() => subirDocumento(tipo)}
                    disabled={subiendo || !documentos[tipo]}
                  >
                    Subir
                  </button>
                </div>
              )}

              <div className="acciones-documento">
                {cliente.documentos?.[tipo] && puedeVerDocumentos ? (
                  <a href={cliente.documentos[tipo]} target="_blank" rel="noopener noreferrer">
                    <FaEye /> Ver
                  </a>
                ) : (
                  <span className="estado-faltante">Faltante</span>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="acciones-grid">
          {puedeVerDeudas && (
            <Link className="accion-card accion-primary" to={`/app/cliente/${id}/deudas`}>
              <FaMoneyCheckAlt />
              <span>Ver Deudas</span>
            </Link>
          )}

          {puedeCrearDeudas && (
            <Link className="accion-card accion-primary" to={`/app/cliente/${id}/deudas/nueva`}>
              <FaPlusCircle />
              <span>Agregar Deuda</span>
            </Link>
          )}

          {puedeEditarCliente && (
            <Link className="accion-card accion-warning" to={`/app/cliente/${id}/editar`}>
              <FaEdit />
              <span>Editar Cliente</span>
            </Link>
          )}

          {puedeDescargarPdf && (
            <>
              <button type="button" onClick={imprimirTarjeta} className="accion-card accion-success">
                <FaPrint />
                <span>Imprimir Tarjeta PDF</span>
              </button>

              <button
                type="button"
                onClick={handleDescargarTarjetaZip}
                className="accion-card accion-success"
                disabled={capturandoTarjeta}
              >
                <FaFileArchive />
                <span>{capturandoTarjeta ? "Generando..." : "Descargar Tarjeta ZIP"}</span>
              </button>
            </>
          )}

          <Link className="accion-card accion-secondary" to="/app/clientes">
            <span>&larr;</span>
            <span>Volver a la lista</span>
          </Link>
        </div>
      </div>

      {mostrarTarjeta && (
        <div className="solo-impresion">
          <TarjetaCliente cliente={{ id, ...cliente }} deudaPrincipal={deudaPrincipal} />
        </div>
      )}

      {capturandoTarjeta && cliente && (
        <div className="tarjetas-captura-ocultas">
          <TarjetaClienteFrenteImagen
            cliente={{ id, ...cliente }}
            deudaPrincipal={deudaPrincipal}
          />
          <TarjetaClienteReversoImagen cliente={{ id, ...cliente }} deudas={deudas} />
        </div>
      )}
    </>
  );
};

export default ClienteDetalle;
